require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-dezeen-hornsby-residence.json") })
        }
      }, "path---journal-dezeen-hornsby-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-dezeen-hornsby-residence!./.cache/json/journal-dezeen-hornsby-residence.json
// module id = 478
// module chunks = 231608221292675